import React from 'react'
import { Controller } from 'react-hook-form'
import ReactSelect, { createFilter } from 'react-select'

import { Box, Flex, Input, InputRightElement, Button } from '@chakra-ui/react'
import FieldWrapper from '../FieldWrapper/FieldWrapper'

import CustomMenuList from './CustomMenuList'
import CustomOption from './CustomOption'
import { isNullish } from '@/utils/helper'
import DeleteButton from '@/components/Elements/Button/DeleteButton'

const SingleSelect = ({
  name,
  options = [],
  allOptions = [],
  disabled = false,
  isRequired = true,
  defaultValue = '',
  extraOnChange = () => {},
  showButton = false,
  buttonText = '',
  buttonFunction = () => {},
  ...rest
}) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
        const inCurrentOptions = options.some((opt) => opt.value === value)

        const inAllOptions = allOptions.some((opt) => opt.value === value)

        const selectedOption =
          options.find((opt) => opt.value === value) || allOptions.find((opt) => opt.value === value) || []

        const selectedOptionLabel = selectedOption?.label || '(-)'

        return (
          <FieldWrapper name={name} error={error} tooltip={selectedOptionLabel} isRequired={isRequired} {...rest}>
            {disabled && <Input w="100%" value={selectedOptionLabel} disabled />}
            {/* {!showSelection && !disabled && (
              <Flex w="100%" gap="3" alignItems={'center'}>
                <Input w="100%" value={selectedOptionLabel} disabled />

                <DeleteButton
                  onClick={() => {
                    onChange('');
                    extraOnChange('');
                  }}
                />
              </Flex>
            )} */}
            {!disabled && (
              <ReactSelect
                ref={ref}
                isMulti={false}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 19999 }),

                  container: () => ({
                    flex: 1,
                  }),
                  control: (base, { isDisabled }) => {
                    let bgColor = 'white'
                    if (value === '' && isRequired) {
                      bgColor = 'yellow'
                    }

                    if (isDisabled) {
                      bgColor = 'hsl(0, 0%, 95%)'
                    }
                    return {
                      ...base,
                      backgroundColor: bgColor,
                      borderColor: '#E2E8F0',
                    }
                  },
                  singleValue: (base) => ({
                    ...base,
                    color: 'hsl(0, 0%, 50%)',
                  }),
                  multiValueRemove: (base, state) => {
                    return state.isDisabled ? { ...base, display: 'none' } : base
                  },
                }}
                filterOption={createFilter({ ignoreAccents: false })}
                options={options}
                value={selectedOption}
                onChange={(option) => {
                  if (disabled) {
                    return
                  }

                  if (!option || option === null) {
                    onChange('')
                    extraOnChange('')

                    return
                  } else {
                    onChange(option.value)
                    extraOnChange(option.value)

                    return
                  }
                }}
                onFocus={() => {
                  const errorElement = document.getElementById(name)
                  if (errorElement) {
                    errorElement.scrollIntoView({
                      behavior: `smooth`,
                      block: 'center',
                    })
                  }
                }}
                onBlur={onBlur}
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                isDisabled={disabled}
                isClearable={!disabled}
                menuPortalTarget={document.body}
              />
            )}
            {showButton && (
              <InputRightElement width="4.5rem">
                <Button h="1.75rem" size="sm" onClick={buttonFunction}>
                  {buttonText}
                </Button>
              </InputRightElement>
            )}
          </FieldWrapper>
        )
      }}
    />
  )
}

export default SingleSelect
